import React from 'react';
import { Route } from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { connect } from 'react-redux';

import theme from '../../theme';

import './index.css';

// Define layout
class StoreLayout extends React.Component {
	render() {
		return (
			<div className="store-wrapper">
					{this.props.children}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {};
};

const mapDispatchToProps = dispatch => {
	return {};
};

const ConnectedLayout = connect(
	mapStateToProps,
	mapDispatchToProps
)(StoreLayout);

export default ({ component: Component, ...rest }) => {
	return (
		<Route
			{...rest}
			render={matchProps => (
				<MuiThemeProvider muiTheme={theme}>
					<ConnectedLayout>
						<Component {...matchProps} />
					</ConnectedLayout>
				</MuiThemeProvider>
			)}
		/>
	);
};
